import { Slide } from "packages/lesson/dist/@types";
import { task as task01 } from "../../../../../task/course-02/lesson-03/task-01";

const task: Slide = {
  title: "Which bark band has the highest bandwith?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
